import { Modal } from 'almanac-ui/Modal'
import { PropsWithChildren } from 'react'
import Styles from '../Root/Root.module.scss'
import cx from 'classnames'
import { ModalProps } from 'almanac-ui/Modal/Types'
import { AriaLabelingProps } from '@react-types/shared'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useInterruptBrowserBack } from '../useInterruptBrowserBack'

export const Root = ({
  children,
  bodyClassName,
  wrapperRef,
  ...props
}: PropsWithChildren<Pick<ModalProps, 'bodyClassName' | 'wrapperRef' | 'onClose'>> &
  Pick<AriaLabelingProps, 'aria-labelledby' | 'aria-describedby'>) => {
  const { isMobile } = useResponsiveDesign()
  useInterruptBrowserBack()

  return (
    <Modal.Root
      size="fullscreen"
      bodyClassName={cx(Styles.root, bodyClassName)}
      aria-labelledby="wizard-header"
      {...props}
      ref={isMobile ? wrapperRef : null}
      wrapperRef={!isMobile ? wrapperRef : null}
    >
      <div className={Styles.content}>{children}</div>
    </Modal.Root>
  )
}
